// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unsaved-changes-dialog{--forge-dialog-width: 480px}`, "",{"version":3,"sources":["webpack://./components/reusable/UnsavedChangesDialog/UnsavedChangesDialog.scss"],"names":[],"mappings":"AAAA,wBACE,2BAAA","sourcesContent":[".unsaved-changes-dialog {\n  --forge-dialog-width: 480px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
